<div class="salon-opening-hours">
  <h2 *ngIf="schedule.length"
      class="h4 dvi-themed-text-color fw-bold"
      [translate]="'SALON-DETAILS.OPENING-HOURS'"></h2>
  <div class="opening-hours-container">
    <div *ngFor="let day of formattedSchedule"
         class="d-flex justify-content-between align-items-center py-3">
      <div class="text-primary">
        {{ day.dayNameAbbrev | translate }}
      </div>
      <div class="dvi-themed-text-color d-flex flex-column">
        <span *ngFor="let slot of day.dayTimeSlots">
          {{ slot }}
        </span>
      </div>
    </div>
  </div>
</div>
